import React from 'react';
import { whyChooseUsDetailed } from '../mock';
import { Briefcase, CurrencyDollar, Lightning, Lifebuoy } from '@phosphor-icons/react';
import useEmblaCarousel from 'embla-carousel-react';

const iconMap = {
  Briefcase: Briefcase,
  DollarSign: CurrencyDollar,
  Zap: Lightning,
  LifeBuoy: Lifebuoy
};

const WhyChooseUsSection = () => {
  const [emblaRef] = useEmblaCarousel({ loop: true, align: 'start' });

  return (
    <section data-testid="why-choose-us-section" className="py-24 bg-[#FAFAFA] hideme">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="rounded-lg overflow-hidden shadow-2xl">
              <img 
                src="/assets/img/whychooseus.webp" 
                alt="Professional attorney at work" 
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Floating stats card */}
            <div className="absolute -bottom-6 -right-6 bg-[#044B3B] text-white p-6 rounded-lg shadow-xl hidden lg:block">
              <div className="text-3xl font-heading font-bold mb-1">98%</div>
              <div className="text-sm text-white/80">Approval Rate</div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#044B3B] mb-3">
              Why Choose Us
            </p>
            <h2 className="text-3xl sm:text-4xl font-heading font-medium text-slate-900 tracking-tight mb-6">
              Built for Results, Not Just Filings
            </h2>
            <p className="text-base text-slate-600 leading-relaxed mb-8">
              We combine legal expertise with transparent pricing and personalized service to deliver trademark protection that actually drives business value.
            </p>

            {/* Grid for desktop, slider for mobile */}
            <div className="grid grid-cols-1 xs:grid-cols-2 gap-5 max-xs:hidden">
              {whyChooseUsDetailed.map((feature) => {
                const Icon = iconMap[feature.icon];
                return (
                  <div
                    key={feature.id}
                    data-testid={`why-card-${feature.id}`}
                    className="bg-white border border-slate-200 hover:border-[#044B3B]/30 hover:bg-[#044B3B] hover:shadow-lg transition-all duration-300 rounded-lg p-6 group"
                  >
                    <div className="w-10 h-10 bg-[#044B3B] rounded-lg flex items-center justify-center mb-4">
                      <Icon className="h-5 w-5 text-white" weight="regular" />
                    </div>
                    <h3 className="text-base font-heading font-semibold text-slate-900 mb-1 group-hover:text-white">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-slate-500 leading-relaxed group-hover:text-white/90">
                      {feature.description}
                    </p>
                  </div>
                );
              })}
            </div>

            {/* Slider for mobile (576px and below) */}
            <div className="overflow-hidden xs:hidden" ref={emblaRef}>
              <div className="flex gap-4">
                {whyChooseUsDetailed.map((feature) => {
                  const Icon = iconMap[feature.icon];
                  return (
                    <div
                      key={feature.id}
                      data-testid={`why-card-${feature.id}`}
                      className="flex-[0_0_85%] bg-white border border-slate-200 hover:border-[#044B3B]/30 hover:bg-[#044B3B] hover:shadow-lg transition-all duration-300 rounded-lg p-6 group"
                    >
                      <div className="w-10 h-10 bg-[#044B3B] rounded-lg flex items-center justify-center mb-4">
                        <Icon className="h-5 w-5 text-white" weight="regular" />
                      </div>
                      <h3 className="text-base font-heading font-semibold text-slate-900 mb-1 group-hover:text-white">
                        {feature.title}
                      </h3>
                      <p className="text-sm text-slate-500 leading-relaxed group-hover:text-white/90">
                        {feature.description}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
